export const userLoginReportSelector = state => (state.administration.reports.userLoginReport.data.pagedCollection);
export const userLoginReportTotalPages = state => (state.administration.reports.userLoginReport.data.totalPages);
